import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SearchBar({ placeholder = 'Search services, studios, talent...', onSearch, autoFocus }) {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      if (onSearch) onSearch(query);
      else navigate(`/explore?q=${encodeURIComponent(query)}`);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex items-center bg-dark-surface border border-dark-border rounded-2xl px-4 py-3 gap-3 focus-within:border-brand-purple transition-colors"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" strokeWidth="2">
        <circle cx="11" cy="11" r="8"/>
        <line x1="21" y1="21" x2="16.65" y2="16.65"/>
      </svg>
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className="flex-1 bg-transparent text-dark-text placeholder-dark-subtext text-sm outline-none"
      />
      {query && (
        <button type="button" onClick={() => setQuery('')} className="text-dark-subtext hover:text-dark-text">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      )}
      <button type="submit" className="bg-brand-gradient text-white text-xs font-semibold px-3 py-1.5 rounded-lg">
        Search
      </button>
    </form>
  );
}
